import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mobile-draws-section" }
const _hoisted_2 = { class: "mobile-draws-header" }
const _hoisted_3 = { class: "mobile-section-title" }
const _hoisted_4 = { class: "mobile-draws-content" }
const _hoisted_5 = { class: "mobile-draws-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mobile-draw-card-content" }
const _hoisted_8 = { class: "mobile-draw-info" }
const _hoisted_9 = { class: "mobile-draw-date" }
const _hoisted_10 = { class: "mobile-draw-time" }
const _hoisted_11 = { class: "mobile-checkbox-container" }
const _hoisted_12 = { class: "mobile-checkbox-custom" }
const _hoisted_13 = {
  key: 0,
  class: "check-mark",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_14 = { class: "mobile-quick-actions" }

import { computed } from 'vue';

const MOBILE_VISIBLE_DRAWS_MAX = 8;

interface Draw {
  event_id: number | string;
  draw_date: string;
  cutoff: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileDrawsSection',
  props: {
    upcomingDraws: { default: () => [] },
    draws: { default: () => [] },
    selectedDraws: { default: () => [] }
  },
  emits: ['update-selected-draws', 'toggle-draw-selection'],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-undef */
const props = __props;

const allDraws = computed(() => {
  const source = props.upcomingDraws?.length ? props.upcomingDraws : (props.draws || []);
  return source.slice(0, MOBILE_VISIBLE_DRAWS_MAX);
});

const emit = __emit;

const isDrawSelected = (index: number) => {
  return !!props.selectedDraws[index];
};

const toggleDraw = (index: number) => {
  emit('toggle-draw-selection', index);
};

const selectAll = () => {
  allDraws.value.forEach((_, index) => {
    if (!props.selectedDraws[index]) {
      emit('update-selected-draws', index, true);
    }
  });
  // Deselect any draws beyond the mobile visible cap
  props.selectedDraws.forEach((selected, index) => {
    if (selected && index >= MOBILE_VISIBLE_DRAWS_MAX) {
      emit('update-selected-draws', index, false);
    }
  });
};

const clearSelectedDraws = () => {
  // Clear all except the first one to ensure minimum selection
  props.selectedDraws.forEach((selected, index) => {
    if (selected && index !== 0) {
      emit('update-selected-draws', index, false);
    }
  });
  // Ensure first is selected if it wasn't
  if (!props.selectedDraws[0]) {
    emit('update-selected-draws', 0, true);
  }
};

const formatDate = (dateStr: string): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (dateStr: string): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('detail.selectDraws')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDraws.value, (draw, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: draw.event_id,
            class: _normalizeClass(["mobile-draw-item", { 'selected': isDrawSelected(index) }]),
            onClick: ($event: any) => (toggleDraw(index))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(formatDate(draw.draw_date)), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(formatTime(draw.draw_date)), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (isDrawSelected(index))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[0] || (_cache[0] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 10, _hoisted_6))
        }), 128))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mobile-separator" }, null, -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "mobile-action-btn primary",
          onClick: selectAll
        }, _toDisplayString(_ctx.$t('draws.selectAll')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "mobile-action-btn secondary",
          onClick: clearSelectedDraws
        }, _toDisplayString(_ctx.$t('draws.clearAll')), 1)
      ])
    ])
  ]))
}
}

})